export default __webpack_public_path__ + "static/media/geeks-academy.11243679.png";